<script>
export default {
  name: 'articles-teaser',
  props: {
    article: {
      type: Object,
      required: false
    },
    category: {
      type: String,
      required: true
    }
  },
  methods: {
    openArticle () {
      this.$router.push({
        'name': 'articles-page',
        'params': {
          'articleSlug': this.article.slug,
          'articleCategory': this.category
        }
      })
    }
  }
}
</script>

<template>
  <article @click="openArticle">
    <header>
      <h2>{{ article.title }}</h2>
      <footer>{{ article.published | format_datetime('Do MMMM YYYY') }}</footer>
    </header>
    <div class="content">{{ article.teaser }}</div>
  </article>
</template>

<style lang="sass" scoped>
@import "~element-theme-chalk/src/common/var.scss"

article
  cursor: pointer

footer
  border-bottom: 1px solid $--border-color-light
  color: $--color-info
  font-size: .8rem
  margin-bottom: .6rem
  padding: .1rem 0
  text-align: left

.content
  opacity: .7

  &:hover
    opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/articles-teaser.vue